import React from 'react';
import { color as palette } from "@/constants/palette";

function EditDocument() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='81'
      height='81'
      viewBox='0 0 81 81'
      fill='none'
    >
      <mask
        id='mask0_563_5820'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='81'
        height='81'
      >
        <rect width='81' height='81' fill={palette.lineStrong} />
      </mask>
      <g mask='url(#mask0_563_5820)'>
        <path
          d='M20.25 74.25C18.3938 74.25 16.8047 73.5891 15.4828 72.2672C14.1609 70.9453 13.5 69.3563 13.5 67.5V13.5C13.5 11.6438 14.1609 10.0547 15.4828 8.73281C16.8047 7.41094 18.3938 6.75 20.25 6.75H44.4656C45.3656 6.75 46.2234 6.91875 47.0391 7.25625C47.8547 7.59375 48.5719 8.07187 49.1906 8.69062L65.5594 25.0594C66.1781 25.6781 66.6562 26.3953 66.9938 27.2109C67.3313 28.0266 67.5 28.8844 67.5 29.7844V35.1C67.5 35.7188 67.3172 36.2531 66.9516 36.7031C66.5859 37.1531 66.1219 37.4906 65.5594 37.7156C64.6594 38.0531 63.8016 38.4891 62.9859 39.0234C62.1703 39.5578 61.425 40.1625 60.75 40.8375L42.525 59.0625C41.9063 59.6813 41.4141 60.3984 41.0484 61.2141C40.6828 62.0297 40.5 62.8875 40.5 63.7875V70.875C40.5 71.8313 40.1766 72.6328 39.5297 73.2797C38.8828 73.9266 38.0812 74.25 37.125 74.25H20.25ZM47.25 70.875V65.3063C47.25 64.8563 47.3344 64.4203 47.5031 63.9984C47.6719 63.5766 47.925 63.1969 48.2625 62.8594L65.8969 45.3094C66.4031 44.8031 66.9656 44.4375 67.5844 44.2125C68.2031 43.9875 68.8219 43.875 69.4406 43.875C70.1156 43.875 70.7625 44.0016 71.3812 44.2547C72 44.5078 72.5625 44.8875 73.0687 45.3937L76.1906 48.5156C76.6406 49.0219 76.9922 49.5844 77.2453 50.2031C77.4984 50.8219 77.625 51.4406 77.625 52.0594C77.625 52.6781 77.5125 53.3109 77.2875 53.9578C77.0625 54.6047 76.6969 55.1813 76.1906 55.6875L58.6406 73.2375C58.3031 73.575 57.9234 73.8281 57.5016 73.9969C57.0797 74.1656 56.6438 74.25 56.1938 74.25H50.625C49.6688 74.25 48.8672 73.9266 48.2203 73.2797C47.5734 72.6328 47.25 71.8313 47.25 70.875ZM69.4406 55.35L72.5625 52.0594L69.4406 48.9375L66.2344 52.1437L69.4406 55.35ZM47.25 30.375H60.75L43.875 13.5V27C43.875 27.9562 44.1984 28.7578 44.8453 29.4047C45.4922 30.0516 46.2938 30.375 47.25 30.375Z'
          fill={palette.primary}
        />
      </g>
    </svg>
  );
}

export default EditDocument;
